import { LearningRoom, RoomType } from '@tryhackme/thm-ui-components';
import { RoomsListProps } from './rooms-list.types';
import { StyledCard } from './rooms-list.styles';
export const RoomsList = ({
  rooms
}: RoomsListProps) => <StyledCard padding="2.4rem 1.6rem" data-sentry-element="StyledCard" data-sentry-component="RoomsList" data-sentry-source-file="rooms-list.tsx">
    {rooms?.length > 0 && rooms.map(({
    code,
    title,
    description,
    image,
    progress,
    type,
    isPublic
  }) => <LearningRoom key={code} title={title} description={description} image={image ?? ''} progressValue={progress} roomType={type ?? RoomType.Challenge} code={code} showCompletedCheckmarks isPublic={isPublic} />)}
  </StyledCard>;